import type { ReactNode } from 'react';
import { columnStyleOf, type ColumnStyle } from '@erp/shared-types';

// Bold reaches past the cell's own weight (the codes draw `font-medium`).
// `contents` keeps the wrapper out of the cell's layout.
const BOLD_CLASS = 'contents font-bold [&_*]:font-bold';

/** A cell drawn with its column's saved formatting. */
export function ColumnStyledCell({
  style,
  children,
}: {
  style: ColumnStyle | undefined;
  children: ReactNode;
}) {
  return columnStyleOf({ style }).bold ? (
    <span className={BOLD_CLASS}>{children}</span>
  ) : (
    children
  );
}
